module.exports = __webpack_public_path__ + "img/electronic-facilities.ac3d02e9.svg";